import React, { useState } from "react";
import PickingListDetaildata from "./table/PickingListDetaildata";
import Barcodedetaildata from "./table/Barcodedetaildata";
import { useNavigate } from "react-router-dom";

export default function BarcodeDetails() {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <div>
        <h2 className="font-Montserrat text-xl font-bold text-black">
          Barcode Details
        </h2>
        <div className="border-b-2 border-blue-200 w-20"></div>
      </div>
      <div class="flex flex-wrap justify-center mt-2">
        <div className="w-full font-Montserrat flex-2 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ml-4">
          <div className="flex flex-wrap   pl-3 mt-1  rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-4 font-medium "> Type:</div>
              <div className="mt-4 mr-8 ml-2 text-gray-700 font-semibold">
                2 X 4m staging platform
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium "> Allocated:</div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                512
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium "> Location:</div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                (Rack A4 - Bay 3-1) or used in assembly or N/A
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Condition of contents:
              </div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                A-stock/B-stock
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                Count in Stock:
              </div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                (Yes) (not counted in stock) or (Disposed){" "}
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Checked in by:
              </div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                Asif
              </div>
            </div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Date of Registration
              </div>
            </div>
          </div>
          <div
            className="flex mt-2 flex-row space-x-2
px-3 py-1 uppercase leading-wide text-gray-700 text-sm font-medium"
          >
            <div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 16.6667H13.3333V13.3333H16.6667V16.6667ZM11.6667 8.33333H8.33333V11.6667H11.6667V8.33333ZM16.6667 8.33333H13.3333V11.6667H16.6667V8.33333ZM6.66667 13.3333H3.33333V16.6667H6.66667V13.3333ZM11.6667 13.3333H8.33333V16.6667H11.6667V13.3333ZM6.66667 8.33333H3.33333V11.6667H6.66667V8.33333ZM20 1.66667V20H0V1.66667H2.5V2.5C2.5 3.41917 3.2475 4.16667 4.16667 4.16667C5.08583 4.16667 5.83333 3.41917 5.83333 2.5V1.66667H14.1667V2.5C14.1667 3.41917 14.9142 4.16667 15.8333 4.16667C16.7525 4.16667 17.5 3.41917 17.5 2.5V1.66667H20ZM18.3333 6.66667H1.66667V18.3333H18.3333V6.66667ZM16.6667 0.833333C16.6667 0.373333 16.2942 0 15.8333 0C15.3725 0 15 0.373333 15 0.833333V2.5C15 2.96 15.3725 3.33333 15.8333 3.33333C16.2942 3.33333 16.6667 2.96 16.6667 2.5V0.833333ZM5 2.5C5 2.96 4.6275 3.33333 4.16667 3.33333C3.70583 3.33333 3.33333 2.96 3.33333 2.5V0.833333C3.33333 0.373333 3.70583 0 4.16667 0C4.6275 0 5 0.373333 5 0.833333V2.5Z"
                  fill="black"
                  fill-opacity="0.8"
                />
              </svg>
            </div>
            <div className="ml-2">26-oct-2021</div>
            <div>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                  fill="black"
                  fill-opacity="0.7"
                />
              </svg>
            </div>
            <div className="ml-2 -mt-0.5">3: 45: pm</div>
          </div>

          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Date of Modified
              </div>
            </div>
          </div>
          <div
            className="flex mt-2 flex-row space-x-2
px-3 py-1 uppercase leading-wide text-gray-700 text-sm font-medium"
          >
            <div>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 16.6667H13.3333V13.3333H16.6667V16.6667ZM11.6667 8.33333H8.33333V11.6667H11.6667V8.33333ZM16.6667 8.33333H13.3333V11.6667H16.6667V8.33333ZM6.66667 13.3333H3.33333V16.6667H6.66667V13.3333ZM11.6667 13.3333H8.33333V16.6667H11.6667V13.3333ZM6.66667 8.33333H3.33333V11.6667H6.66667V8.33333ZM20 1.66667V20H0V1.66667H2.5V2.5C2.5 3.41917 3.2475 4.16667 4.16667 4.16667C5.08583 4.16667 5.83333 3.41917 5.83333 2.5V1.66667H14.1667V2.5C14.1667 3.41917 14.9142 4.16667 15.8333 4.16667C16.7525 4.16667 17.5 3.41917 17.5 2.5V1.66667H20ZM18.3333 6.66667H1.66667V18.3333H18.3333V6.66667ZM16.6667 0.833333C16.6667 0.373333 16.2942 0 15.8333 0C15.3725 0 15 0.373333 15 0.833333V2.5C15 2.96 15.3725 3.33333 15.8333 3.33333C16.2942 3.33333 16.6667 2.96 16.6667 2.5V0.833333ZM5 2.5C5 2.96 4.6275 3.33333 4.16667 3.33333C3.70583 3.33333 3.33333 2.96 3.33333 2.5V0.833333C3.33333 0.373333 3.70583 0 4.16667 0C4.6275 0 5 0.373333 5 0.833333V2.5Z"
                  fill="black"
                  fill-opacity="0.8"
                />
              </svg>
            </div>
            <div className="ml-2">26-oct-2021</div>
            <div>
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                  fill="black"
                  fill-opacity="0.7"
                />
              </svg>
            </div>
            <div className="ml-2 -mt-0.5">3: 45: pm</div>
          </div>
          <div className="flex flex-wrap   pl-3   rounded-xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-50 py-2 font-medium ">
                {" "}
                Modified by:
              </div>
              <div className="mt-2 mr-8 ml-2 text-gray-700 font-semibold">
                Asif
              </div>
            </div>
          </div>
        </div>
        <div className="w-full  flex-1 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ">
          <div className="">
            <button
              type="button"
              className="text-white bg-green-100 focus:bg-green-200 hover:bg-green-200 px-3 py-1 float-right font-Montserrat font-medium text-base rounded-md"
              //   onClick={() => navigate("/dashboard/warehouse/printscan/barcode-details")}
              onClick={() => {
                setShowModal(true);
              }}
            >
              Move Location{" "}
            </button>
          </div>
          {showModal ? (
            <>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative m-auto ">
                  {/*content*/}
                  <div
                    className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none"
                    style={{ width: "60vw" }}
                  >
                    {/*header*/}
                    <button
                      type="button"
                      class="text-red-400  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2"
                      onClick={() => setShowModal(false)}
                    >
                      <svg
                        className="mr-1"
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1.5L11 11.5M1 11.5L11 1.5"
                          stroke="#E40000"
                          stroke-opacity="0.6"
                          stroke-width="2"
                        />
                      </svg>
                      Close
                    </button>

                    {/*body*/}
                    <div className="flex flex-wrap justify-center">
                      <div
                        className="tabelcontainer overflow-auto "
                        // "w-[calc(100vw_-_12rem)]"
                      >
                        {/* <Itemsdata /> */}
                        <Barcodedetaildata />
                      </div>
                    </div>
                    {/*footer*/}
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}
        </div>
      </div>

      <div className="flex flex-wrap justify-center">
        <div
          className="tabelcontainer overflow-auto mx-4"
          // "w-[calc(100vw_-_12rem)]"
        >
          {/* <Itemsdata /> */}
          <PickingListDetaildata />
        </div>
      </div>

      <div className="flex flex-row justify-center my-10">
        <button
          type="button"
          className="text-red-600 font-Montserrat space-x-128  font-medium text-lg"
          // onClick={() => Navigate("/dashboard/management/customer-dashboard")}
        >
          Cancel
        </button>

        <button
          type="submit"
          className="text-white ml-auto space-x-128  bg-green-100 hover:bg-green-200 font-Montserrat font-semibold  place-content-center rounded-md py-1 px-8 flex flex-shrink-1 "
          onClick={() =>
            navigate("/dashboard/warehouse/printscan/printbarcode-batches-items")
          }
        >
          Print Barcode
        </button>
      </div>
    </div>
  );
}
